import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LineItemType, Money } from '../../type/order';
import { LineItem } from './LineItem';
import { PerMinuteFeeCharge } from './PerMinuteFeeCharge';
/**
 * A request for real-time access to the court record
 */
export class RealTimeLineItem extends LineItem {
    constructor() {
        super(...arguments);
        this.type = LineItemType.RealTime;
    }
}
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Per-minute rate for real-time streaming service - e.g. price we charge customer for 1 minute of real-time streaming
     */
    )
], RealTimeLineItem.prototype, "connectionFee", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Paid connection fee for real-time streaming service
     */
    )
], RealTimeLineItem.prototype, "perMinuteRate", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Total paid per-minute usage fees for real-time streaming service - e.g. total price we charged customer for duration of
     * the real-time service they have consumed (this only includes paid fees)
     */
    )
], RealTimeLineItem.prototype, "connectionFeePaid", void 0);
__decorate([
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * Details of all per-minute usage fees charges, including an unpaid one if applicable. Returned data includes
     * duration and timeframe we charged for. Sorted in ascending order by payment date.
     */
    )
], RealTimeLineItem.prototype, "perMinuteFeePaidTotal", void 0);
__decorate([
    Type(() => PerMinuteFeeCharge),
    __metadata("design:type", Array)
], RealTimeLineItem.prototype, "perMinuteFeeCharges", void 0);
